import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {
  @Input() data: Array<any> = [];
  dataval: Array<any> = [];
  @Input() title: string;
  @Input() bstCheck;

  constructor() {}
  ngOnInit(): void {}
  async ngOnChanges(changes: SimpleChanges) {
    this.dataval = this.data;
    console.log(this.dataval, 'dataVal');
  }

  ngOnDestroy(): void {}
}
